import React from 'react';

import InstaPostsWrapper from '../InstaPostsWrapper';

export default function Posts() {
  return (
    <div>
      <InstaPostsWrapper />
    </div>
  );
}
